import BookingHelper from '@/store/booking_stores/BookingHelper';

export default ({$fetcher: fetchData} = {}) => {
  return {
    namespaced: true,
    state: {
      categoriesList: [],
      translationCategoriesList: [],
      allCategories: [],
      category: '',
      subject: '',
      vatDecisionReference: '',
      acceptedVatFreePolicy: false,
      errors: {
        category: {name: 'categoryError', errors: []},
        vatFreePolicy: {name: 'vatFreePolicyError', errors: []},
        subject: {name: 'subjectError', errors: []},
      }
    },
    getters: {
      getCategoryData(state) {
        return state.categoriesList.flatMap((category) => category.items).find((item) => item.id === +state.category) || {};
      }
    },
    actions: {
      getCategories({commit}, params) {
        return new Promise((resolve, reject) => {
          fetchData.getCategories(params).then((data) => {
            commit('setCategories', data.collection);
            resolve(data);
          }).catch((error) => {
            reject(error);
          });
        });
      },
      getTranslationCategories({commit}) {
        return new Promise((resolve, reject) => {
          fetchData.getTranslationCategories().then((data) => {
            commit('setTranslationCategories', data.translationMethods);
            resolve(data);
          }).catch((error) => {
            reject(error);
          });
        });
      },
      getAllCategories({commit}) {
        return new Promise((resolve, reject) => {
          fetchData.getAllCategories().then((data) => {
            commit('setAllCategories', data.jobCategories);
            resolve(data);
          }).catch((error) => {
            reject(error);
          });
        });
      },
      getCustomerCategories({commit}, {enterpriseId, departmentId, headers}) {
        return new Promise((resolve, reject) => {
          fetchData.getCategories(enterpriseId, departmentId, headers).then((data) => {
            commit('setCategories', data.categories);
            resolve(data);
          }).catch((error) => {
            reject(error);
          });
        });
      },
    },
    mutations: {
      ...BookingHelper().mutations,
      setCategories(state, data) {
        state.categoriesList = data;
      },
      setTranslationCategories(state, data) {
        state.translationCategoriesList = [...data, {id: 'other', name: 'Other'}];
      },
      setAllCategories(state, data) {
        state.allCategories = data;
      },
      setSubject(state, value) {
        state.subject = value;
      },
      setVatDecisionReference(state, value) {
        state.vatDecisionReference = value;
      },
      setAcceptedVatFreePolicy(state, value) {
        state.acceptedVatFreePolicy = value;
      },
      setCategory(state, value) {
        state.category = value;
        state.subject = '';
      },
      clearStore(state) {
        state.subject = '';
        state.category = '';
        state.categoryList = '';
      }
    }
  };
};
